import { ApiErrorUtils } from '../../../utils/api-error.utils';

export type ErrorType =
  | 'none'
  | 'loading'
  | 'notReady'
  | 'loadError'
  | 'notFound'
  | 'noData';

export interface ErrorCheckInput {
  guid: string | undefined;
  isLoadingSurvey: boolean;
  isLoadingMetrics: boolean;
  surveyError: unknown;
  metricsError: unknown;
  survey: unknown;
  metricsLength: number;
}

export interface ErrorCheckResult {
  errorType: ErrorType;
  shouldShowError: boolean;
}

export class ErrorStateResolver {
  public static checkForErrors(input: ErrorCheckInput): ErrorCheckResult {
    const {
      guid,
      isLoadingSurvey,
      isLoadingMetrics,
      surveyError,
      metricsError,
      survey,
      metricsLength,
    } = input;

    if (!guid) {
      return { errorType: 'none', shouldShowError: false };
    }

    if (isLoadingSurvey || isLoadingMetrics) {
      return { errorType: 'loading', shouldShowError: true };
    }

    if (ApiErrorUtils.isForbiddenError(surveyError) || ApiErrorUtils.isForbiddenError(metricsError)) {
      return { errorType: 'notReady', shouldShowError: true };
    }

    if (surveyError || metricsError) {
      return { errorType: 'loadError', shouldShowError: true };
    }

    if (!survey) {
      return { errorType: 'notFound', shouldShowError: true };
    }

    if (metricsLength === 0) {
      return { errorType: 'noData', shouldShowError: true };
    }

    return { errorType: 'none', shouldShowError: false };
  }
}
